import { Action, createReducer, on } from '@ngrx/store';
import { IUserBlockedUpdateRequest, IUserBlockedUpdateResponse } from '../models/block.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { updateUserUnBlockedRequest, updateUserUnBlockedSuccess, updateUserUnBlockedFailure } from '../actions/block.actions';

export const userUnblockedFeatureKey = 'userUnblocked';

export interface UserUnBlockedState {
  unblockUserRequest: IUserBlockedUpdateRequest;
  unblockUserSuccess: IUserBlockedUpdateResponse;
  unblockUserFailure: IGenericError<ErrorResponse>;
}

export const initialState: UserUnBlockedState = {
  unblockUserRequest: undefined,
  unblockUserSuccess: undefined,
  unblockUserFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(updateUserUnBlockedRequest, (state, action) => ({
    ...state,
    unblockUserRequest: action.request
  })),
  on(updateUserUnBlockedSuccess, (state, action) => ({
    ...state,
    unblockUserSuccess: action.response
  })),
  on(updateUserUnBlockedFailure, (state, action) => ({
    ...state,
    unblockUserFailure: action.error
  }))
);

export const getUnBlockUserRequest = (state: UserUnBlockedState) => state.unblockUserRequest;
export const getUnBlockUserResponse = (state: UserUnBlockedState) => state.unblockUserSuccess;
export const getUnBlockUserFailure = (state: UserUnBlockedState) => state.unblockUserFailure;
